import _APP_STORE_IOS_ICON from '../../public/images/icons/app-store-ios.svg'
import _APP_STORE_ICON from '../../public/images/icons/app-store.svg'
import _FACEBOOK_ICON from '../../public/images/icons/facebook.svg'
import _FAVICON from '../../public/images/icons/favicon.ico'
import _INSTAGRAM_ICON from '../../public/images/icons/instagram.svg'
import _INVERTED_HORIZONTAL_LOGO from '../../public/images/icons/InvertedHorizontalLogo.svg'
import _KLARNA_ICON from '../../public/images/icons/klarna.svg'
import _ADVANCED_LEVELS_ICON from '../../public/images/icons/level-advanced.svg'
import _ALL_LEVELS_ICON from '../../public/images/icons/level-all.svg'
import _BEGINNER_LEVELS_ICON from '../../public/images/icons/level-beginner.svg'
import _INTERMEDIATE_LEVELS_ICON from '../../public/images/icons/level-intermediate.svg'
import _MASTERCARD_ICON from '../../public/images/icons/mastercard.svg'
import _PAYPAL_ICON from '../../public/images/icons/paypal.svg'
import _PLAY_STORE_ICON from '../../public/images/icons/play-store.svg'
import _QUARTER_STAR_ICON from '../../public/images/icons/quarter-star.svg'
import _SPOT_ICON from '../../public/images/icons/spot.svg'
import _THREE_QUARTER_STAR_ICON from '../../public/images/icons/three-quarter-star.svg'
import _VISA_ICON from '../../public/images/icons/visa.svg'
import _YOUTUBE_ICON from '../../public/images/icons/youtube.svg'

export const ALL_LEVELS_ICON = _ALL_LEVELS_ICON
export const BEGINNER_LEVELS_ICON = _BEGINNER_LEVELS_ICON
export const INTERMEDIATE_LEVELS_ICON = _INTERMEDIATE_LEVELS_ICON
export const ADVANCED_LEVELS_ICON = _ADVANCED_LEVELS_ICON
export const APP_STORE_IOS_ICON = _APP_STORE_IOS_ICON
export const APP_STORE_ICON = _APP_STORE_ICON
export const FACEBOOK_ICON = _FACEBOOK_ICON
export const INSTAGRAM_ICON = _INSTAGRAM_ICON
export const INVERTED_HORIZONTAL_LOGO = _INVERTED_HORIZONTAL_LOGO
export const KLARNA_ICON = _KLARNA_ICON
export const MASTERCARD_ICON = _MASTERCARD_ICON
export const PAYPAL_ICON = _PAYPAL_ICON
export const PLAY_STORE_ICON = _PLAY_STORE_ICON
export const QUARTER_STAR_ICON = _QUARTER_STAR_ICON
export const SPOT_ICON = _SPOT_ICON
export const THREE_QUARTER_STAR_ICON = _THREE_QUARTER_STAR_ICON
export const VISA_ICON = _VISA_ICON
export const YOUTUBE_ICON = _YOUTUBE_ICON
export const FAVICON = _FAVICON
